import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router-dom/es/Link';
import { AssetPreview, AssetTileView } from 'signoxe/components';
import { Box } from 'signoxe/components/layout';
import { Button, Popup } from 'signoxe/components/widgets';
import { AssetPropType } from 'signoxe/constants/propTypes';
import { getFilteredAssets } from 'signoxe/selectors';
import './styles.scss';

class AssetPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAssetPicker: false,
    };
  }

  static propTypes = {
    selected: PropTypes.object,
    assets: AssetPropType,
    onSelectAsset: PropTypes.func,
  };

  handleCancelPickAsset = () => this.hideAssetPicker();

  handleClickPickAsset = () => this.showAssetPicker();

  handleSelectAsset = (asset) => {
    this.hideAssetPicker();
    this.props.onSelectAsset(asset);
  }

  hideAssetPicker() {this.setState({showAssetPicker: false}); }

  render() {
    const {selected, assets} = this.props;

    return (
      <Box className="asset-picker" direction="row">
        {selected && <AssetPreview asset={selected} size="64px"/>}
        {selected && <span className="asset-picker__name">{selected.name}</span>}
        <Button onClick={this.handleClickPickAsset}>{selected ? 'Change' : 'Pick'}</Button>
        {this.state.showAssetPicker &&
        <Popup className="asset-picker__popup" title="Select Asset to use for message"
               onCancel={this.handleCancelPickAsset}>
          <AssetTileView assets={assets} onAssetClick={this.handleSelectAsset}/>
          <Box className="asset-picker__toolbar" direction="row" alignItems="center"
               justifyContent="flex-end">
            <Link className="button" to="/assets/new/web">Create new Asset</Link>
          </Box>
        </Popup>}
      </Box>
    );
  }

  showAssetPicker() {
    this.setState({showAssetPicker: true});
  }
}

export default connect(
  (state) => ({assets: getFilteredAssets(state)}),
)(AssetPicker);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetPicker/index.js